import * as React from "react";
import { Field } from "react-final-form";
import { Col } from "react-bootstrap";

export default class InterruptorSN extends React.Component<InterruptorSNProps> {

    render() {
        const { className } = this.props;

        return (
            <Field name={this.props.name} type="checkbox">
                {({ input, meta }) => (
                    <div>
                        <div >
                            <Col xs={2} md={2} className="col-switch sn-switch">
                                <div className="div-sn">NO</div>
                            </Col>
                            <Col xs={6} md={4} className="col-switch">
                                <label className="switch">
                                    <input type="checkbox"  {...input} className={className ? className.concat(" form-control") : "form-control"}/>
                                    <span className="slider round" />
                                </label>
                            </Col>
                            <Col xs={2} md={2} className="col-switch sn-switch">
                                <div className="div-sn">SI</div>
                            </Col>
                        </div>
                        <div>
                            {meta.error && <span className={"text-danger"}>{meta.error}</span>}
                        </div>
                    </div>
                )}
            </Field>
        );
    }

}

interface InterruptorSNProps {
    name: string,
    className?: string
}



// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_general/componentes/InterruptorSN.tsx